// // // // // // // // import React from 'react';
// // // // // // // // import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';  // Correct imports for v6
// // // // // // // // import './App.css';
// // // // // // // // import logo from './logo.svg';

// // // // // // // // // Dummy authentication function (replace with actual auth logic)
// // // // // // // // const isAuthenticated = () => {
// // // // // // // //   return false; // Change to 'false' to test redirection
// // // // // // // // };

// // // // // // // // // Example of a Protected Page
// // // // // // // // const ProtectedPage = () => {
// // // // // // // //   return (
// // // // // // // //     <div>
// // // // // // // //       <h2>Protected Page</h2>
// // // // // // // //       <p>This page is protected and can only be accessed if authenticated.</p>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // const HomePage = () => {
// // // // // // // //   return (
// // // // // // // //     <div className="App">
// // // // // // // //       <header className="App-header">
// // // // // // // //         <img src={logo} className="App-logo" alt="logo" />
// // // // // // // //         <p>
// // // // // // // //           Edit <code>src/App.js</code> and save to reload.
// // // // // // // //         </p>
// // // // // // // //         <a
// // // // // // // //           className="App-link"
// // // // // // // //           href="https://reactjs.org"
// // // // // // // //           target="_blank"
// // // // // // // //           rel="noopener noreferrer"
// // // // // // // //         >
// // // // // // // //           Learn React
// // // // // // // //         </a>
// // // // // // // //       </header>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // function App() {
// // // // // // // //   return (
// // // // // // // //     <BrowserRouter>
// // // // // // // //       <Routes>
// // // // // // // //         {/* Define routes here */}
// // // // // // // //         <Route path="/" element={<HomePage />} />
// // // // // // // //         {/* Use Navigate for protected route */}
// // // // // // // //         <Route
// // // // // // // //           path="/protected"
// // // // // // // //           element={isAuthenticated() ? <ProtectedPage /> : <Navigate to="/" />}
// // // // // // // //         />
// // // // // // // //         {/* Add other routes here */}
// // // // // // // //       </Routes>
// // // // // // // //     </BrowserRouter>
// // // // // // // //   );
// // // // // // // // }

// // // // // // // // export default App;


// // // // // // // // /////////////////////////////////////////////////////////////




// // // // // // import React from 'react';
// // // // // // import { BrowserRouter as Router, Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
// // // // // // import './App.css';

// // // // // // import { ThemeProvider, createTheme } from '@mui/material/styles';

// // // // // // // Import your page components

// // // // // // import LoginSignupAll from './Components/SignupPages/LoginSignupAll';
// // // // // // import AdminLayout from './Pages/AdminLayout';
// // // // // // import Layout from './Components/Layout/Layout';
// // // // // // import AllUserList from './Pages/OperatorRegistration/AllUserList';
// // // // // // import LoginPage from './Pages/LoginPage';

// // // // // // // Define a simple authentication check (replace with real logic)
// // // // // // // const isAuthenticated = () => {
// // // // // // //   return true; // Change to 'true' to simulate an authenticated user
// // // // // // // };

// // // // // // // // Protected Route Component
// // // // // // // const ProtectedRoute = ({ element: Element, ...rest }) => {
// // // // // // //   return isAuthenticated() ? <Element {...rest} /> : <Navigate to="/" />;
// // // // // // // };

// // // // // // const theme = createTheme({
// // // // // //   typography: {
// // // // // //     fontFamily: "Roboto, Arial, sans-serif", // Default font for body
// // // // // //     h1: {
// // // // // //       fontFamily: "Poppins",
// // // // // //       fontWeight: "bold",
// // // // // //       fontSize: "50px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "40px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     h2: {
// // // // // //       fontFamily: "Poppins",
// // // // // //       fontWeight: "medium",
// // // // // //       fontSize: "40px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "30px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     h3: {
// // // // // //       fontFamily: "Poppins",
// // // // // //       fontWeight: "normal",
// // // // // //       fontSize: "30px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "22px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     h6: {
// // // // // //       fontFamily: "Poppins",
// // // // // //       fontWeight: "medium",
// // // // // //       fontSize: "18px",
// // // // // //       color: "#252525",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "16px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     h5: {
// // // // // //       fontFamily: "Poppins",
// // // // // //       fontWeight: "medium",
// // // // // //       fontSize: "16px",
// // // // // //       color: "#252525",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "14px", // Larger font size for larger screens
// // // // // //       },

// // // // // //     },

// // // // // //     body1: {
// // // // // //       fontFamily: "Roboto",
// // // // // //       fontWeight: "normal",
// // // // // //       fontSize: "14px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "11px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     body2: {
// // // // // //       fontFamily: "Roboto",
// // // // // //       fontWeight: "bold",
// // // // // //       fontSize: "16px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "14px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     subtitle1: {
// // // // // //       fontFamily: "Roboto",
// // // // // //       fontWeight: "normal",
// // // // // //       fontSize: "15px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "13px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     subtitle2: {
// // // // // //       fontFamily: "poppins",
// // // // // //       fontWeight: "normal",
// // // // // //       fontSize: "16px",
// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "12px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },
// // // // // //     button: {
// // // // // //       fontFamily: "Roboto", // Buttons will use Poppins
// // // // // //       fontWeight: "normal",
// // // // // //       textTransform: "uppercase", // Optional: makes text uppercase
// // // // // //       fontSize: "16px",

// // // // // //       [`@media (max-width:600px)`]: {
// // // // // //         fontSize: "12px", // Larger font size for larger screens
// // // // // //       },
// // // // // //     },


// // // // // //   },
// // // // // //   components: {
// // // // // //     // MuiButton: {
// // // // // //     //   styleOverrides: {
// // // // // //     //     root: {
// // // // // //     //       fontFamily: "Poppins", // Ensure Poppins applies to buttons
// // // // // //     //       fontWeight: "bold",
// // // // // //     //       fontSize: "0.875rem",
// // // // // //     //       textTransform: "uppercase", // Optional: uppercase for buttons
// // // // // //     //     },
// // // // // //     //   },
// // // // // //     // },
// // // // // //     MuiListItemText: {
// // // // // //       styleOverrides: {
// // // // // //         primary: {
// // // // // //           fontFamily: "Poppins", // Custom font
// // // // // //           fontWeight: "medium",
// // // // // //           fontSize: "16px",
// // // // // //         }
// // // // // //       }
// // // // // //     },
// // // // // //     MuiListItem: {
// // // // // //       styleOverrides: {
// // // // // //         primary: {
// // // // // //           fontFamily: "Poppins", // Custom font
// // // // // //           fontWeight: "medium",
// // // // // //           fontSize: "16px",
// // // // // //         }
// // // // // //       }
// // // // // //     },
// // // // // //     MuiMenuItem: {
// // // // // //       styleOverrides: {
// // // // // //         root: {
// // // // // //           fontFamily: "Roboto", // Menu items use Roboto
// // // // // //           fontSize: "1rem",
// // // // // //           fontWeight: "normal",
// // // // // //         },
// // // // // //       },
// // // // // //     },
// // // // // //   },
// // // // // // });


// // // // // // function App() {
// // // // // //   return (
// // // // // //     <div className="App">
// // // // // //       <ThemeProvider theme={theme}>
// // // // // //         <Router>
// // // // // //           <Routes>
// // // // // //             <Route path="/login" element={<LoginPage />} />
// // // // // //             <Route path="*" element={<Layout />} />
// // // // // //           </Routes>
// // // // // //         </Router>
// // // // // //       </ThemeProvider>
// // // // // //     </div>
// // // // // //   );
// // // // // // }

// // // // // // export default App;




// // // // // import React, { useEffect } from 'react';
// // // // // import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// // // // // import { useDispatch } from 'react-redux';
// // // // // // import { setUserRoleAndPermissions } from './features/auth/authSlice';
// // // // // // import Sidebar from './components/Sidebar/Sidebar';

// // // // // import { setUserRoleAndPermissions } from './ReduxStore/Slices/authSlice';
// // // // // import Sidebar from './Pages/Sidebar';
// // // // // import Dashboard from './Pages/Dashboard/Dashboard';
// // // // // import RegistrationApproval from './Pages/Management/RegistrationApproval/RegistrationApproval';
// // // // // import AllUserList from './Pages/OperatorRegistration/AllUserList';
// // // // // import UserRole from './Pages/Masters/UserRole/UserRole';

// // // // // const App = () => {
// // // // //   const dispatch = useDispatch();

// // // // //   useEffect(() => {
// // // // //     // Simulating fetching user data from an API (this should be dynamic)
// // // // //     const userRole = 'management';  // Example role (could be dynamic based on user data)
// // // // //     const userPermissions = ['view_dashboard', 'view_registration_approval'];  // Example permissions

// // // // //     dispatch(setUserRoleAndPermissions({ role: userRole, permissions: userPermissions }));
// // // // //   }, [dispatch]);

// // // // //   return (
// // // // //     <Router>
// // // // //       <div className="app">
// // // // //         <Sidebar />
// // // // //         <div className="content">
// // // // //           <Routes>
// // // // //             <Route path="/dashboard" element={<Dashboard />} />
// // // // //             <Route path="/registration-approval" element={<RegistrationApproval />} />
// // // // //             <Route path="/user-management" element={<AllUserList />} />
// // // // //             <Route path="/reports" element={<UserRole />} />
// // // // //           </Routes>
// // // // //         </div>
// // // // //       </div>
// // // // //     </Router>
// // // // //   );
// // // // // };

// // // // // export default App;


// // // // import React, { useEffect } from 'react';
// // // // import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// // // // import { useDispatch, useSelector } from 'react-redux';
// // // // // import { loginUser } from './features/auth/authSlice';
// // // // import Sidebar from './Pages/Sidebar';
// // // // import Dashboard from './Pages/Dashboard/Dashboard';
// // // // import RegistrationApproval from './Pages/Management/RegistrationApproval/RegistrationApproval';
// // // // import AllUserList from './Pages/OperatorRegistration/AllUserList';
// // // // import UserRole from './Pages/Masters/UserRole/UserRole';
// // // // import Login from './Pages/LoginPage';


// // // // const App = () => {
// // // //   const dispatch = useDispatch();
// // // //   const { isLoggedIn } = useSelector((state) => state.auth);  // Access login state from Redux

// // // //   useEffect(() => {
// // // //     // Simulating fetching user data from an API or localStorage (for example)
// // // //     // If the user is already logged in, set their role and permissions
// // // //   }, [dispatch]);

// // // //   return (
// // // //     <Router>
// // // //       <div className="app">
// // // //         {isLoggedIn ? (
// // // //           <>
// // // //             <Sidebar />
// // // //             <div className="content">
// // // //               <Routes>
// // // //                 <Route path="/dashboard" element={<Dashboard />} />
// // // //                 <Route path="/registration-approval" element={<RegistrationApproval />} />
// // // //                 <Route path="/user-management" element={<AllUserList />} />
// // // //                 <Route path="/reports" element={<UserRole />} />
// // // //                 <Route path="*" element={<Navigate to="/dashboard" />} />
// // // //               </Routes>
// // // //             </div>
// // // //           </>
// // // //         ) : (
// // // //           <Routes>
// // // //             <Route path="/login" element={<Login />} />
// // // //             <Route path="*" element={<Navigate to="/login" />} />
// // // //           </Routes>
// // // //         )}
// // // //       </div>
// // // //     </Router>
// // // //   );
// // // // };

// // // // export default App;


// // // import React, { useEffect } from 'react';
// // // import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// // // import { useDispatch, useSelector } from 'react-redux';
// // // import Sidebar from './Pages/Sidebar';
// // // import Dashboard from './Pages/Dashboard/Dashboard';
// // // import RegistrationApproval from './Pages/Management/RegistrationApproval/RegistrationApproval';
// // // import AllUserList from './Pages/OperatorRegistration/AllUserList';
// // // import UserRole from './Pages/Masters/UserRole/UserRole';
// // // import Login from './Pages/LoginPage';
// // // import rolePermissions from './utils/rolePermissions';  // Ensure correct rolePermissions

// // // const App = () => {
// // //   const dispatch = useDispatch();
// // //   const { isLoggedIn, role } = useSelector((state) => state.auth); // Access login state from Redux

// // //   const permissions = rolePermissions[role] || [];

// // //   // Private Route handler for roles
// // //   const ProtectedRoute = ({ children, allowedRoles }) => {
// // //     if (!isLoggedIn) {
// // //       return <Navigate to="/login" />;
// // //     }
// // //     if (!allowedRoles.some((r) => permissions.includes(r))) {
// // //       return <Navigate to="/dashboard" />;
// // //     }
// // //     return children;
// // //   };

// // //   useEffect(() => {
// // //     // Simulate fetching user data, if needed
// // //   }, [dispatch]);

// // //   return (
// // //     <Router>
// // //       <div className="app">
// // //         {isLoggedIn ? (
// // //           <>
// // //             <Sidebar />
// // //             <div className="content">
// // //               <Routes>
// // //                 {/* Protect Dashboard route */}
// // //                 <Route
// // //                   path="/dashboard"
// // //                   element={
// // //                     <ProtectedRoute allowedRoles={['admin', 'super_admin', 'management', 'operator']}>
// // //                       <Dashboard />
// // //                     </ProtectedRoute>
// // //                   }
// // //                 />
// // //                 {/* Protect Registration Approval route */}
// // //                 <Route
// // //                   path="/registration-approval"
// // //                   element={
// // //                     <ProtectedRoute allowedRoles={['admin', 'super_admin', 'management']}>
// // //                       <RegistrationApproval />
// // //                     </ProtectedRoute>
// // //                   }
// // //                 />
// // //                 {/* Protect User Management route */}
// // //                 <Route
// // //                   path="/user-management"
// // //                   element={
// // //                     <ProtectedRoute allowedRoles={['admin', 'super_admin', 'management', 'operator']}>
// // //                       <AllUserList />
// // //                     </ProtectedRoute>
// // //                   }
// // //                 />
// // //                 {/* Protect Reports route */}
// // //                 <Route
// // //                   path="/reports"
// // //                   element={
// // //                     <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
// // //                       <UserRole />
// // //                     </ProtectedRoute>
// // //                   }
// // //                 />
// // //                 {/* Default route to dashboard if no match */}
// // //                 <Route path="*" element={<Navigate to="/dashboard" />} />
// // //               </Routes>
// // //             </div>
// // //           </>
// // //         ) : (
// // //           <Routes>
// // //             <Route path="/login" element={<Login />} />
// // //             <Route path="*" element={<Navigate to="/login" />} />
// // //           </Routes>
// // //         )}
// // //       </div>
// // //     </Router>
// // //   );
// // // };

// // // export default App;


// // import React, { useEffect } from 'react';
// // import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // // import Sidebar from './Pages/Sidebar';
// // import Dashboard from './Pages/Dashboard/Dashboard';
// // import RegistrationApproval from './Pages/Management/RegistrationApproval/RegistrationApproval';
// // import AllUserList from './Pages/OperatorRegistration/AllUserList';
// // import UserRole from './Pages/Masters/UserRole/UserRole';
// // import Login from './Pages/LoginPage';
// // import Sidebar from './Components/SideNav/Sidebar';
// // import Layout from './Components/Layout/Layout';

// // const ProtectedRoute = ({ children, permission }) => {
// //   const { isLoggedIn, permissions } = useSelector((state) => state.auth);

// //   if (!isLoggedIn) {
// //     return <Navigate to="/login" />;
// //   }

// //   // Check if the user has the required permission
// //   if (!permissions.includes(permission)) {
// //     return <Navigate to="/dashboard" />;
// //   }

// //   return children;
// // };

// // const App = () => {
// //   const dispatch = useDispatch();
// //   const { isLoggedIn } = useSelector((state) => state.auth);

// //   useEffect(() => {
// //     // Simulate fetching user data or token to check login status
// //   }, [dispatch]);

// //   return (
// //     <Router>
// //       <div className="app">
// //         {isLoggedIn ? (
// //           <Routes>
// //             <Route path="/" element={<Layout />} />
// //           </Routes>
// //         ) : (
// //           <Routes>
// //             <Route path="/login" element={<Login />} />
// //             <Route path="*" element={<Navigate to="/login" />} />
// //           </Routes>
// //         )}
// //       </div>
// //     </Router>
// //   );
// // };

// // export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import Login from './Pages/LoginPage';
// import Layout from './Components/Layout/Layout';

// const App = () => {
//   const { isLoggedIn } = useSelector((state) => state.auth);

//   return (
//     <Router>
//       <Routes>
//         {isLoggedIn ? (
//           <>
//             {/* <Route path="/" element={<Navigate to="/dashboard" />} /> */}
//             <Route path="/*" element={<Layout />} />
//           </>
//         ) : (
//           <>
//             <Route path="/login" element={<Login />} />
//             {/* <Route path="*" element={<Navigate to="/login" />} /> */}
//           </>
//         )}
//       </Routes>
//     </Router>
//   );
// };

// export default App;


import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Pages/LoginPage';
import Layout from './Components/Layout/Layout';
import { ThemeProvider } from '@emotion/react';
import { createTheme, Typography } from '@mui/material';
import './App.css'
import Dashboard from './Pages/Dashboard/Dashboard';
import ProtectedRoute from './Pages/PrivateRoute';



const theme = createTheme({
  typography: {
    fontFamily: "Roboto, Arial, sans-serif", // Default font for body
    CustomSideBarText: {
      fontFamily: "Roboto",
      // fontWeight: "bold",
      // color:"red",
      fontSize: "16px",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },
    h1: {
      fontFamily: "Poppins",
      fontWeight: "bold",
      fontSize: "50px",
      [`@media (max-width:600px)`]: {
        fontSize: "40px", // Larger font size for larger screens
      },
    },
    h2: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "40px",
      [`@media (max-width:600px)`]: {
        fontSize: "30px", // Larger font size for larger screens
      },
    },
    h3: {
      fontFamily: "Poppins",
      fontWeight: "normal",
      fontSize: "30px",
      [`@media (max-width:600px)`]: {
        fontSize: "22px", // Larger font size for larger screens
      },
    },
    h6: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "18px",
      color: "#252525",
      [`@media (max-width:600px)`]: {
        fontSize: "16px", // Larger font size for larger screens
      },
    },
    h5: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "16px",
      color: "#252525",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },

    },

    body1: {
      fontFamily: "Roboto",
      fontWeight: "normal",
      fontSize: "14px",
      [`@media (max-width:600px)`]: {
        fontSize: "11px", // Larger font size for larger screens
      },
    },
    body2: {
      fontFamily: "Roboto",
      fontWeight: "bold",
      fontSize: "16px",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },
    subtitle1: {
      fontFamily: "Roboto",
      fontWeight: "normal",
      fontSize: "15px",
      [`@media (max-width:600px)`]: {
        fontSize: "13px", // Larger font size for larger screens
      },
    },
    subtitle2: {
      fontFamily: "poppins",
      fontWeight: "normal",
      fontSize: "16px",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    button: {
      fontFamily: "Roboto", // Buttons will use Poppins
      fontWeight: "normal",
      textTransform: "uppercase", // Optional: makes text uppercase
      fontSize: "16px",

      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },


  },
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       fontFamily: "Poppins", // Ensure Poppins applies to buttons
    //       fontWeight: "bold",
    //       fontSize: "0.875rem",
    //       textTransform: "uppercase", // Optional: uppercase for buttons
    //     },
    //   },
    // },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: "Poppins", // Custom font
          fontWeight: "medium",
          fontSize: "16px",
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        primary: {
          fontFamily: "Poppins", // Custom font
          fontWeight: "medium",
          fontSize: "16px",
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Roboto", // Menu items use Roboto
          fontSize: "1rem",
          fontWeight: "normal",
        },
      },
    },
  },
});


// const App = () => {
//   const { isLoggedIn } = useSelector((state) => state.auth);

//   return (

//     <ThemeProvider theme={theme}>

//       <Router>
//         <Routes>
//           {/* Public Routes */}
//           {!isLoggedIn ? (
//             <>
//               <Route path="/" element={<Login />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </>
//           ) : (
//             // Protected Routes
//             <>
//               <Route path="/*" element={<Layout />} />
//               {/* <Route path="*" element={<Navigate to="/" />} /> */}
//             </>
//           )}
//         </Routes>
//       </Router>
//     </ThemeProvider>
//   );
// };

// export default App;



const App = () => {
  // const { isLoggedIn } = useSelector((state) => state.auth);

  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* <Route path="/protect" element={<ProtectedRoute />} /> */}

          {/* Public Routes */}
          {/* {!isLoggedIn ? ( */}
          {!isAuthenticated ? (
            <>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            // Protected Routes
            <>
              <Route path="/*" element={<Layout />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;